import { CollectedSurcharge } from '../../../domain/invoicing/invoice'

export type CollectedSurchargeLine = {
  key: 'surcharge' | 'amount-paid'
  label: string
  amount: number
}

export const collectedSurchargeLines = (paid: CollectedSurcharge): CollectedSurchargeLine[] => {
  if (!(paid.collectedSurcharge > 0) || !(paid.amountPaid > 0) || !paid.collectedSurchargeLabel) {
    return []
  }
  return [
    { key: 'surcharge', label: paid.collectedSurchargeLabel, amount: paid.collectedSurcharge },
    { key: 'amount-paid', label: 'Amount Paid', amount: paid.amountPaid }
  ]
}
